<ng-container *ngIf="emailContent; else loadingScreen">
  <!--  -->

  <!-- Desktop -->
  <ng-container *ngIf="!emailBuilderIsMobile">
    <div class="email-builder-new-desktop">
      <div class="email-builder-new-desktop-controls">
        <div class="control-wrapper">
          <ng-container *ngTemplateOutlet="emailSetup"></ng-container>
          <div style="height: 24px"></div>
          <ng-container *ngTemplateOutlet="emailAdvancedSettings"></ng-container>
        </div>
      </div>
      <div class="email-builder-new-desktop-blocks-list" cdkScrollable>
        <div class="blocks-wrapper">
          @if (showKeyboardShortcut) {
            <glxy-alert
              [border]="true"
              type="tip"
              [showClose]="true"
              (close)="showKeyboardShortcut = false"
              style="margin: 16px 24px 0"
            >
              <span
                [innerHTML]="
                  'EMAIL_BUILDER.EMAIL_PREVIEW.PREVIEW_EMAIL_SHORTCUT_TIP'
                    | translate: { metaKey: platformIsMac ? 'Cmd' : 'Ctrl' }
                "
              ></span>
            </glxy-alert>
          }

          <ng-container *ngTemplateOutlet="emailBlocksList"></ng-container>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #desktopPreviewTemplate let-dialogRef="dialogRef">
    <email-editor-preview [html]="renderedTemplate">
      <ng-content select="[preview_header]" ngProjectAs="[preview_header]" preview_header></ng-content>

      <button mat-icon-button email_preview_modal_close_button class="modal-close-button" (click)="dialogRef.close()">
        <mat-icon>close</mat-icon>
      </button>
    </email-editor-preview>
  </ng-template>

  <!-- Mobile -->
  <ng-container *ngIf="emailBuilderIsMobile">
    <mat-tab-group animationDuration="0ms">
      <mat-tab label="{{ 'EMAIL_BUILDER.MAT_LABELS.EDIT_EMAIL' | translate }}">
        <ng-template matTabContent>
          <ng-container *ngTemplateOutlet="emailSetup"></ng-container>
          <ng-container *ngTemplateOutlet="emailBlocksList"></ng-container>
        </ng-template>
      </mat-tab>

      <mat-tab label="{{ 'EMAIL_BUILDER.MAT_LABELS.PREVIEW' | translate }}">
        <email-editor-preview [html]="renderedTemplate" [previewIsMobile]="true">
          <ng-content select="[preview_header]" ngProjectAs="[preview_header]" preview_header></ng-content>
        </email-editor-preview>
      </mat-tab>

      <mat-tab label="{{ 'EMAIL_BUILDER.MAT_LABELS.ADVANCED' | translate }}">
        <ng-container *ngTemplateOutlet="emailAdvancedSettings"></ng-container>
      </mat-tab>
    </mat-tab-group>
  </ng-container>
</ng-container>

<ng-template #loadingScreen>
  <glxy-loading-spinner [fullWidth]="true" [fullHeight]="true"></glxy-loading-spinner>
</ng-template>

<!-- ==================================== -->
<!--              Templates               -->
<!-- ==================================== -->

<!-- Email Controls Tab: Subject -->
<ng-template #emailSetup>
  <form #emailSetupForm="ngForm">
    <div class="email-settings-container">
      <glxy-form-field>
        <glxy-label>{{ 'EMAIL_BUILDER.SUBJECT_CONTROLS_TAB.TEMPLATE_NAME' | translate }}</glxy-label>
        <input matInput required [(ngModel)]="emailContent.name" name="Template Name" autocomplete="off" />
      </glxy-form-field>
    </div>

    @if (emailBuilderIsMobile) {
      <mat-divider></mat-divider>
    } @else {
      <div style="height: 8px"></div>
    }

    <div class="email-settings-container">
      <glxy-form-field>
        <glxy-label>{{ 'EMAIL_BUILDER.SUBJECT_CONTROLS_TAB.SUBJECT_LINE' | translate }}</glxy-label>
        <input
          #subjectLine
          #subjectLineModel="ngModel"
          matInput
          required
          [(ngModel)]="emailContent.subjectLine"
          name="Subject Line"
          autocomplete="off"
          sharedContainsValidDynamicContent
        />
        <email-dynamic-component-selector
          glxySuffix
          [target]="subjectLine"
          [(model)]="emailContent.subjectLine"
        ></email-dynamic-component-selector>
        <glxy-error *ngIf="subjectLineModel.hasError('invalidDynamicComponent') && subjectLineModel.touched">
          {{ 'EMAIL_BUILDER.VALIDATION_ERRORS.DYNAMIC_CONTENT' | translate }}
        </glxy-error>
      </glxy-form-field>

      <glxy-form-field>
        <glxy-label>{{ 'EMAIL_BUILDER.SUBJECT_CONTROLS_TAB.INBOX_PREVIEW' | translate }}</glxy-label>
        <glxy-label-hint>{{ 'EMAIL_BUILDER.SUBJECT_CONTROLS_TAB.INBOX_PREVIEW_HINT' | translate }}</glxy-label-hint>
        <input
          #previewText
          #previewTextModel="ngModel"
          matInput
          [(ngModel)]="emailContent.previewText"
          name="Inbox Preview Text"
          autocomplete="off"
          sharedContainsValidDynamicContent
        />
        <email-dynamic-component-selector
          glxySuffix
          [target]="previewText"
          [(model)]="emailContent.previewText"
        ></email-dynamic-component-selector>
        <glxy-error *ngIf="previewTextModel.hasError('invalidDynamicComponent') && previewTextModel.touched">
          {{ 'EMAIL_BUILDER.VALIDATION_ERRORS.DYNAMIC_CONTENT' | translate }}
        </glxy-error>
      </glxy-form-field>
    </div>
  </form>
</ng-template>

<!-- Email Controls Tab: Content List -->
<ng-template #emailBlocksList>
  <email-blocks-list
    [blocks]="emailContent.emailContentBlocks"
    [optionalBlockTypes]="optionalBlockTypes"
  ></email-blocks-list>
</ng-template>

<!-- Email Controls Tab: Page Setup -->
<ng-template #emailAdvancedSettings>
  <email-advanced-settings
    [emailSetup]="emailContent.emailSetup"
    [sectionsEnabled]="advancedSections"
  ></email-advanced-settings>
</ng-template>
